module.exports = __webpack_public_path__ + "static/media/6.59a85924.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/6.png
// module id = 1375
// module chunks = 0